import { render, staticRenderFns } from "./notificator.vue?vue&type=template&id=22eafe83"
import script from "./notificator.vue?vue&type=script&lang=js"
export * from "./notificator.vue?vue&type=script&lang=js"
import style0 from "./notificator.vue?vue&type=style&index=0&id=22eafe83&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports